import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { FavouriteSpaceQuery } from './FavouriteSpaceQuery.graphql';

export function preloadSpaceStarTextButton(spaceKey: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: FavouriteSpaceQuery,
		variables: {
			spaceKey,
		},
	});
}
